<template>
	<div class="index-box" @mouseleave="leaveTar()">
		<loginDialog ref="loginDialog" />

		<div class="top-one">
			<div class="topBar" :class="{ blackY: blackShadow == true }">
				<div style="width: 1000px;display: flex;margin: auto">
					<div class="img-box">
						<img src="@/assets/newImg5/logo2.png" @click="$router.push({ path: '/' })"
							style="cursor: pointer;width: 100px;height: 82px;">
					</div>
					<div class="title-box" style="cursor: pointer" @mouseleave="hiddenNav(1)">

						<div class="title-item" @click="toRoute(1)" @mouseenter="showNav(1)"
							:class="{ bgc2: wzsb == 1 }">
							QSOU广场</div>
						<div class="title-item" @mouseenter="showNav(3)" :class="{ bgc2: wzsb == 3 }">
							原料资讯</div>

						<!-- <div class="title-item" @click="toRoute(5)" @mouseenter="showNav(2)"
							:class="{ bgc: videoShow == true, bgc2: wzsb == 2 }">
							<div>
								<span>视频 </span>
							</div>
						</div> -->
					</div>

					<div class="icon-box">
						<el-input v-model="inputData" placeholder="请输入内容" style="padding-top: 18px; width: 223px"
							class="custom-button" @keyup.enter.native="showSearch"></el-input>

						<img src="@/assets/newImg/联集 1@1x.png"
							style="width: 25px; height: 24px; padding: 26px 14px; cursor: pointer" alt=""
							@click="showSearch" @mouseover="handleMouseLeave4()" />
						<div style="width: 50px;">
							<img v-if="!imgUrl" src="@/assets/newImg/组 4@1x.png" @click="goUser()"
								@mouseover="handleMouseOver4"
								style="width: 25px; height: 24px; padding: 26px 14px; cursor: pointer" alt="" />
							<img :src="imgUrl" v-else @click="goUser()" @mouseover="handleMouseOver4"
								style="width: 29px; height: 28px; padding: 26px 6px; cursor: pointer; border-radius: 50%"
								alt="" />
							<div class="showType4" v-if="userShow" @mouseleave="handleMouseLeave4()">
								<div style="padding: 14px 22px 2px 27px; width: 100%; cursor: pointer; height: 33px"
									class="userH" @click="goUser()" v-show="userId">个人中心</div>
								<div style="padding: 9px 22px 2px 27px; width: 100%; cursor: pointer; height: 33px"
									class="userH" @click="logOut2" v-show="!userId">前往登录</div>
								<div style="padding: 14px 22px 2px 27px; width: 100%; cursor: pointer; height: 33px"
									class="userH" @click="logOut" v-show="userId">退出登录</div>
							</div>
						</div>
					</div>


				</div>
				<div class="showType3" @mouseleave="hiddenNav(2)" v-show="materialShow" @mouseenter="changeW()">
					<div class="showType3Box">
						<div class="boxItem" @click="goCater(item)" v-for="(item, index) in allMater.slice(0, 5)"
							:key="item.value">
							<div class="rotateBox"></div>
							<div style="text-align: center;">
								<img :src="item.image" class="boxImg" alt="" v-if="iconList[index]">
								<img :src="item.xImage" class="boxImg" alt="" v-else-if="!iconList[index]">
							</div>
							<div class="btn" :style="getBorderStyle(item)">{{ item.label }}</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getGoodsIndustryAdvisory, getBstGoodsGategory1, getBstGoodsGategoryAndSon } from "@/api/user";
import { color } from "echarts/lib/theme/light";
export default {
	data() {
		return {
			iconList: [true, true, true, true, true,],
			allMater: [],
			imgUrl: "",
			blackShadow: false,
			inputData: "",
			quoteShow: false,
			materialShow: false,
			classifyList: [],
			videoShow: false,
			search: false,
			areaCategoryList2: [],
			areaCategoryList: [],
			wzsb: 1,
			classify: 99999,
			path: "",
			userShow: false,
			userId: ""
		};
	},
	methods: {
		getBorderStyle(item) {
			return {
				border: `1px solid ${item.color}`,
				color: `${item.color}`
			};
		},
		iconEnter(indexs) {
			this.iconList.forEach((item, index) => {
				this.$set(this.iconList, index, true)
			})
			this.$set(this.iconList, indexs, false)

		},
		goCater(item) {
			this.wzsb = 3
			const { href } = this.$router.resolve({
				path: 'materInformation',
				query: { id: item.value, label: item.label }

			});
			window.open(href, '_blank');
			this.materialShow = false
		},
		showNav(index) {
			this.materialShow = true
			this.wzsb = index
			if (index == 2 || index == 1) {
				this.materialShow = false

			}
		},
		hiddenNav(index) {
			this.iconList.forEach((item, index) => {
				this.$set(this.iconList, index, true)
			})
			if (index == 2) {
				this.materialShow = false
			}
			if (this.$route.path.includes("/vudio")) {
				this.blackShadow = true;
			}
			if (window.location.pathname == '/materInformation') {
				this.wzsb = 3;
			} else if (window.location.pathname == '/hotVideo') {
				this.wzsb = 2;
			} else if (window.location.pathname == '/') {
				this.wzsb = 1;
			} else {
				this.wzsb = 0
			}
		},
		changeW() {
			this.wzsb = 3;

		},

		leaveTar() {
			this.quoteShow = false;
			this.videoShow = false;
			this.userShow = false;
		},
		overF() {
			this.quoteShow = false;
			this.videoShow = false;
			this.userShow = false;
		},
		goTitle(row) {
			const { href } = this.$router.resolve({
				path: "store",
				query: {
					gId: row.gId
				}
			});
			window.open(href, "_blank");
		},
		toRoute(id) {
			console.log(id, "id");
			if (id == 1) {
				this.path = "/";
				console.log(this.path, "ddd");
			} else if (id == 2) {
				this.path = "/store";
			} else if (id == 3) {
				this.path = "/squareSou";
			} else if (id == 4) {
				this.path = "/consult";
			} else if (id == 5) {
				this.path = "/hotVideo";
			} else if (id == 6) {
				this.path = "/quotedPrice";
			}

			if (this.$route.path == this.path) {
				return;
			} else {
				console.log("执行了吗", this.path);
				const { href } = this.$router.resolve({
					path: this.path
				});
				window.open(href, "_blank");
			}
		},
		showSearch() {
			const { href } = this.$router.resolve({
				path: "/search",
				query: {
					label: this.inputData
				}
			});
			window.open(href, "_blank");
		},
		goToday(data) {
			console.log(data);
			this.radio2 = data.gId;
			const { href } = this.$router.resolve({
				path: "/todayQuotedPrice",
				query: {
					data: JSON.stringify({
						catOne: this.radio,
						catTwo: this.radio2
					})
				}
			});
			window.open(href, "_blank");
		},

		materialMouse(data, index) {
			this.classify = index;
			// this.radio = data.gId
			// let getArr = this.areaCategoryList.filter((item, index) => {
			//     return item.gId == data.gId
			// })

			// getBstGoodsGategory1ByPid({ p_id: data.gId }).then((res) => {
			//     this.areaCategoryList2 = res.data.data
			// })
		},
		toConsult(index) {
			const { href } = this.$router.resolve({
				path: "/titleDetails",
				query: {
					id: this.IndustryInformationList[index].bgcId
				}
			});
			window.open(href, "_blank");
		},
		goVideo(item) {
			const { href } = this.$router.resolve({
				path: "/hotVideo",
				query: {
					industry: item.gId
				}
			});
			window.open(href, "_blank");
		},
		logOut() {
			this.imgUrl = "";
			this.userId = "";
			this.$bus.$emit("loginCancel", (data) => {

			});
			this.$nextTick(() => {
				this.$refs.loginDialog.loginDialog();
			});
			this.userShow = false;
			window.localStorage.removeItem("user_id");
			window.localStorage.removeItem("token");
			window.localStorage.removeItem("userName");
			window.localStorage.removeItem("headPic");
		},
		logOut2() {

			// this.$router.push({ path: '/' })
			this.$nextTick(() => {

				this.$refs.loginDialog.loginDialog();
			});
		},
		goVideo2(item) {
			const { href } = this.$router.resolve({
				path: "/quotedPrice",
				query: {
					cat_one: item.gId,
					label: item.label
				}
			});
			window.open(href, "_blank");
		},
		handleMouseOver() {
			this.videoShow = true;
			this.quoteShow = false;
		},
		handleMouseLeave() {
			this.videoShow = false;
		},
		handleMouseOver2() {
			this.quoteShow = true;
			this.videoShow = false;
		},
		handleMouseLeave2() {
			this.quoteShow = false;
		},

		handleMouseOver3() {
			this.quoteShow = false;
			this.videoShow = false;
		},
		handleMouseOver4() {
			this.quoteShow = false;
			this.videoShow = false;
			this.userShow = true;
		},
		OneMouseOver() {
			this.quoteShow = false;
			this.videoShow = false;
		},
		handleMouseLeave3(index) {
		},
		handleMouseLeave4(index) {
			this.userShow = false;
		},
		// handleMouseLeaveAll() {
		//     this.quoteShow = false
		//     this.videoShow = false
		//     this.materialShow = false
		// },
		toVedio(row) {
			const { href } = this.$router.resolve({
				path: "/vudio",
				query: {
					v_id: row.vId,
					industry: this.$route.query.cat_id,
					industry2: this.$route.query.cat_id2
				}
			});
			window.open(href, "_blank");
		},
		goUser() {
			// let a = window.localStorage.getItem('user_id')
			if (!window.localStorage.getItem("user_id")) {
				this.$nextTick(() => {
					this.$refs.loginDialog.loginDialog();
				});

				// this.$message.warning({
				//     message: '请先登录',
				//     offset: 100,
				// })
				// return this.$router.push({
				//     path: '/login'
				// })
			} else if (this.$route.path == "/buyerCenter/home") {
				return;
			} else {
				const { href } = this.$router.resolve({
					path: "buyerCenter/home"
				});
				window.open(href, "_blank");
			}

			// if (this.$route.path == '/buyerCenter/home') {
			//     return
			// } else {
			//     const { href } = this.$router.resolve({
			//         path: "buyerCenter/home",
			//     });
			//     window.open(href, "_blank");
			// }
		}
	},
	created() { },
	mounted() {
		console.log(window.location, 'window.location.href');

		this.$bus.$on("loginSuccess", (data) => {
			this.imgUrl = data.imgUrl;
			this.userId = data.userId;
		});
		this.$bus.$on("loginCancel", (data) => {
			this.imgUrl = ''

		});
		this.imgUrl = window.localStorage.getItem("headPic");
		if (this.$route.path.includes("/vudio")) {
			this.blackShadow = true;
		}
		this.userId = window.localStorage.getItem("user_id");
		if (window.location.pathname == '/materInformation') {
			this.wzsb = 3;
		} else if (window.location.pathname == '/hotVideo') {
			this.wzsb = 2;
		} else if (window.location.pathname == '/') {
			this.wzsb = 1;
		} else {
			this.wzsb = 0
		}
		getBstGoodsGategoryAndSon({}).then((res) => {
			console.log(res);
			this.allMater = res.data.data

		})
		// getBstGoodsGategory1().then((res) => {
		// 	this.areaCategoryList = res.data.data;
		// }),
		// getGoodsIndustryAdvisory().then((res) => {
		// 	this.classifyList = res.data.data;
		// });
	}
};
</script>

<style lang="scss" scoped>
.bgc {
	color: rgb(32, 123, 255) !important;
}

.index-box {
	font-family: "Microsoft YaHei" !important;
	width: 100%;
	position: relative;
	z-index: 1999;

	.showType {
		font-size: 14px;
		padding-top: 12px;
		padding-left: 12px;
		display: flex;
		position: absolute;
		// left: calc(492px);
		top: 80px;
		width: 30rem;
		height: 10rem;
		background: linear-gradient(92deg, rgba(255, 255, 255, 0.76) 0%, rgba(255, 255, 255, 0.76) 100%);
		backdrop-filter: blur(55px);

		z-index: 9999;
		flex-wrap: wrap;
		color: #333333;
		border-radius: 6px; // font-size: 18px;
	}

	.showType2 {
		font-size: 14px;
		padding-top: 12px;
		padding-left: 12px;
		display: flex;
		position: absolute;
		// left: calc(590px);
		top: 80px;
		width: 30rem;
		height: 10rem;
		background: linear-gradient(92deg, rgba(255, 255, 255, 0.76) 0%, rgba(255, 255, 255, 0.76) 100%);
		backdrop-filter: blur(55px);

		z-index: 9999;
		flex-wrap: wrap;
		color: #333333;
		border-radius: 6px; // font-size: 18px;
	}

	.showType4 {
		font-size: 14px;
		// padding-top: 12px;
		// padding-left: 12px;
		// display: flex;
		// position: absolute;
		width: 8rem;
		// height: 5.3rem;
		background: linear-gradient(92deg, rgba(255, 255, 255, 0.76) 0%, rgba(255, 255, 255, 0.76) 100%);
		backdrop-filter: blur(55px);
		// left: calc(65% + 528px);
		top: 74px;
		z-index: 9999;
		flex-wrap: wrap;
		color: #333333;
		border-radius: 6px; // font-size: 18px;
	}

	.showType3 {
		font-size: 14px;
		padding-top: 12px;
		padding-left: 12px;
		width: 100vw;
		height: 170px;
		background-color: white;
		display: flex;
		position: absolute;
		top: 70px;
		backdrop-filter: blur(55px);
		z-index: 9999;
		flex-wrap: wrap;
		color: #333333;
		border-radius: 6px;

		.showType3Box {
			width: 1000px;
			// background-color: pink;
			margin: auto;
			height: 85%;
			display: flex;
			box-sizing: border-box;

			.boxItem {
				width: 200px;
				padding: 20px 5px;
				color: #333333;
				font-family: "Microsoft YaHei Light";
				cursor: pointer;
				border: 2px solid transparent;
				/* 初始边框为透明 */
				transition: all 0.8s ease;
				font-size: 14px;
				position: relative;
				overflow: hidden;

				.rotateBox {
					position: absolute;
					top: 10px;
					left: 20px;
					width: 100%;
					height: 26px;
					background-color: white;
					z-index: 9999;
					transform-origin: left top;
					transition: all 0.8s ease;
					/* 旋转中心设置为左下角 */
					transform: rotate(90deg);
				}

				.boxImg {
					vertical-align: middle;
					width: 48px;
					height: 48px;
					margin-right: 1px;
					margin: auto;
				}

				.btn {
					width: 125px;
					height: 30px;
					border: 2px solid #333333;
					border-radius: 30px;
					text-align: center;
					margin: auto;
					margin-top: 10px;
					transition: all 0.8s ease;
					margin-top: 15px;
					line-height: 29px;
				}


			}

			// .boxItem:hover {
			// 	color: rgb(32, 123, 255);
			// 	border: 2px solid #227BFF;
			// 	border-radius: 10px;
			// }

			// .boxItem:hover .btn {
			// 	background-color: #227BFF;
			// 	color: white;
			// 	border: 2px solid #227BFF;
			// }

			.boxItem:hover .rotateBox {
				transform-origin: left top;
				/* 旋转中心设置为左下角 */
				transform: rotate(-60deg);
			}


		}
	}

	.videoColor:hover {
		color: rgb(32, 123, 255) !important;
	}
}

.blackY {
	box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25) !important;
}

.topBar {
	box-shadow: 0px 3px 2px 0px rgba(0, 0, 0, 0.05);

	color: #333333;
	width: 100vw;
	height: 80px;
	z-index: 1500 !important;
	// opacity: 1;
	position: fixed;
	top: 0px;
	display: flex;
	background: linear-gradient(92deg, rgba(255, 255, 255, 0.76) 0%, rgba(255, 255, 255, 0.76) 100%);
	backdrop-filter: blur(20px);

	// background-color: rgb(211, 239, 247);
	.bottomBar {
		width: 100vw;
		height: 50px;
		background-color: pink;
	}

	.img-box {
		height: 100%;
		margin-right: 20px;
	}

	.title-box {
		display: flex;
		width: 59%;
		// margin-left: 80px;
		color: #333333;
		font-size: 18px;

		.title-item {
			padding: 1.8rem 1.1rem 1rem 1rem;
			font-family: "Microsoft YaHei Light";
		}

		.title-item:hover {
			color: rgb(32, 123, 255) !important;
		}
	}

	.icon-box {
		display: flex;
		margin: right;
		// cursor: pointer;
	}
}



.bgc2 {
	font-size: 24px;
	color: #227bff;
	padding-bottom: 9px;
	line-height: 26px;
}

.userH:hover {
	color: #227bff;
}

::v-deep {
	.el-input__inner {
		border-radius: 19px;
	}
}
</style>
